<template>
  <div id="app" :class="{isHidden:isHidden}" class=" size12 backF5">
    <router-view/>
  </div>
</template>

<script>
import {carriers} from '../src/api/getSearch.js'
import LocalStorage from '@/common/localStorage.js'
export default {
  name: 'App',
  data() {
    return {
      isHidden:false
    }
  },
  created() {
    let vm = this
    if(window.frameElement && window.frameElement.src) {
      vm.isHidden  = true
    }
    carriers().then((res) => {
      LocalStorage.set('carriers', JSON.stringify(res))
    })
  }
}
</script>

<style>
  *{
    font-family:Microsoft YaHei;
  }
  .isHidden{
    height: 100%;
    overflow: hidden;
  }
#app {
  /*min-width: 1100px;*/
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue